/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_LinkInputs */

const en_cap_full_link = /** @type {(inputs: Cap_Full_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the AI infrastructure case study`)
};

const lv_cap_full_link = /** @type {(inputs: Cap_Full_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasīt par AI infrastruktūru`)
};

/**
* | output |
* | --- |
* | "Read the AI infrastructure case study" |
*
* @param {Cap_Full_LinkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_link = /** @type {((inputs?: Cap_Full_LinkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_LinkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_link(inputs)
	return en_cap_full_link(inputs)
});